import { DefaultTemplateWrapper } from "@src/components/templates/DefaultTemplateWrapper";
import { AccountBeforeConfirmTemplate } from "@src/components/templates/AccountBeforeConfirmTemplate"
import { FooterInjector } from "@src/injectors/global/FooterInjector";
import { TitleInjector } from "@src/injectors/global/TitleInjector";
import { AccountBeforeConfirmInjector } from "@src/injectors/account/AccountBeforeConfirmInjector";
import { ComponentProps } from "react";

/**
 * お申し込み前の確認ページ
 * @returns {JSX.Element | null}
 * @constructor
 */
export default function AccountBeforeConfirm() {
  const wrapper: ComponentProps<typeof DefaultTemplateWrapper> = {
    footer: FooterInjector(),
    header: {
      headingCategory: {
        children: "",
      },
      primaryH1: {
        children: "",
      },
    },
  };
  return (
    <>
      {TitleInjector()}
      <DefaultTemplateWrapper {...wrapper}>
        {AccountBeforeConfirmTemplate(AccountBeforeConfirmInjector())}
      </DefaultTemplateWrapper>
    </>
  );
}
